<div class="screenshot-dialog">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <div>
      <h5 class="mb-0">Screenshot da conexão</h5>
      <small class="text-muted font-monospace">{{ connection.connectionId }}</small>
    </div>
    <button type="button" class="icon-button" (click)="close()" aria-label="Fechar">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="screenshot-body">
    <div class="d-flex justify-content-center py-5" *ngIf="loading()">
      <app-progress-spinner></app-progress-spinner>
    </div>

    <div class="text-center py-5 text-muted" *ngIf="!loading() && error()">
      <i class="fa-solid fa-triangle-exclamation text-warning mb-2 d-block" style="font-size: 2rem;"></i>
      Não foi possível carregar o screenshot desta conexão.
      <div class="small">Verifique se a conexão possui um pod ativo.</div>
    </div>

    <div class="text-center" *ngIf="!loading() && !error() && imageUrl()">
      <img [src]="imageUrl()" alt="Screenshot da conexão" class="screenshot-image" />
    </div>
  </div>

  <div class="d-flex gap-2 mt-3">
    <button type="button" class="btn btn-primary" (click)="load()" [disabled]="loading()">
      <i class="fa-solid fa-arrows-rotate"></i>
      {{ loading() ? 'Carregando...' : 'Atualizar' }}
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="close()" [disabled]="loading()">Fechar</button>
  </div>
</div>
